import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BaseInputsGrid from "@reusables/BaseInputsGrid";
import BaseTextarea from "@reusables/BaseTextarea";
import { SaleOrdersFormTyping } from "@components/Dashboard/pages/Sales/Orders/components/MutationLayout/types";

export default function CommentSection() {
    const { t } = useTranslation("", { keyPrefix: "sales.orders.general" });
    const { control } = useFormContext<SaleOrdersFormTyping>();

    return (
        <BaseInputsGrid cols={1}>
            <Controller
                control={control}
                name="comment"
                render={({ field }) => (
                    <div>
                        <BaseTextarea
                            label={t("fields.comment.label")}
                            value={field.value ?? ""}
                            placeholder={t("fields.comment.placeholder")}
                            onChange={(value) => field.onChange(value)}
                            height={"112px"}
                        />
                        <div className="mt-[8px] text-sm font-thin text-gray-400">
                            {t("fields.comment.pdfVisibilityNote")}
                        </div>
                    </div>
                )}
            />
        </BaseInputsGrid>
    );
}
